import React, {FC, useState} from "react"

import FormattedMessage, {injectIntl, InjectIntl} from "@irati/utils/lang"
import {H2, Body} from "@irati/ui/src/Typography"
import Flex from "@irati/ui/src/Flex"
import GenericModal from "@irati/ui/src/GenericModal"
import Button from "@irati/ui/src/Button"
import {useTheme} from "@irati/ui/src/global/useTheme"
import ErrorText from "@irati/ui/src/ErrorText"

import {Img} from "../styled"

interface Props extends InjectIntl {
  show: boolean
  error?: string
  onClose: () => void
}

const ErrorResponseModal: FC<Props> = ({show, error, onClose, formatMessage}) => {
  const [hint, setHint] = useState(false)

  const theme = useTheme()

  return (
    <GenericModal customWidth={700} hideActions show={show} onHide={onClose}>
      <Flex justifyContent="center" padding={[6, 3, 3]}>
        <Img width="200px" src={formatMessage({id: "admin.components.integration.directorySync.hris.upsell.responseModal.error.img"})} />
      </Flex>
      <H2 color={theme.colors.tertiary.r_400} marginBottom={2} paddingLeft={3}>
        <FormattedMessage id="admin.components.integration.directorySync.hris.upsell.responseModal.error.title" />
      </H2>
      <Body marginBottom={4} paddingLeft={3}>
        <FormattedMessage id="admin.components.integration.directorySync.hris.upsell.responseModal.error.subTitle" />
      </Body>
      <Flex justifyContent="flex-end" paddingRight={3} paddingBottom={error || hint ? 1 : 4}>
        <Button primary large onClick={() => setHint(true)}>
          <FormattedMessage id="admin.components.integration.directorySync.hris.upsell.responseModal.error.button" />
        </Button>
      </Flex>
      {hint && (
        <Flex justifyContent="flex-end" paddingRight={3}>
          <Body small color={theme.colors.greys.mediumDark}>
            <FormattedMessage id="admin.components.integration.directorySync.hris.upsell.responseModal.error.subText" />
          </Body>
        </Flex>
      )}
      {error && (
        <Flex justifyContent="flex-end" paddingRight={3} paddingBottom={4}>
          <ErrorText>{error}</ErrorText>
        </Flex>
      )}
    </GenericModal>
  )
}

export default injectIntl(ErrorResponseModal)
